package org.zq.linkgame.data

import org.zq.linkgame.ui.model.AppLanguage
import org.zq.linkgame.ui.model.BackgroundTheme
import kotlinx.browser.localStorage

private const val KEY_BACKGROUND_THEME = "background_theme"
private const val KEY_LANGUAGE = "app_language"

actual class SettingsStorage actual constructor() {
    actual fun saveBackgroundTheme(theme: BackgroundTheme) {
        localStorage.setItem(KEY_BACKGROUND_THEME, theme.name)
    }
    
    actual fun getBackgroundTheme(): BackgroundTheme {
        val themeName = localStorage.getItem(KEY_BACKGROUND_THEME)
        return try {
            if (themeName != null) {
                BackgroundTheme.valueOf(themeName)
            } else {
                BackgroundTheme.SKY
            }
        } catch (e: Exception) {
            BackgroundTheme.SKY
        }
    }
    
    actual fun saveLanguage(language: AppLanguage) {
        localStorage.setItem(KEY_LANGUAGE, language.name)
    }
    
    actual fun getLanguage(): AppLanguage {
        val langName = localStorage.getItem(KEY_LANGUAGE)
        return try {
            if (langName != null) {
                AppLanguage.valueOf(langName)
            } else {
                AppLanguage.SYSTEM
            }
        } catch (e: Exception) {
            AppLanguage.SYSTEM
        }
    }
}
